<template>
  <div class="col-xl-6 mb-3 mb-xl-0" v-loading="loading">
    <div class="col-xl-12 col-lg-6">
      <card header-classes="bg-transparent">
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Faturamento Por Data Vencimento
            </h6>
          </div>
          <div class="col">
            <el-select
              v-model="month"
              placeholder="Selecione  uma opção"
              @change="initBigChart()"
            >
              <el-option
                v-for="row of options"
                :key="row.key"
                :label="row.label"
                :value="row.key"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="card card-stats mb-4 mb-xl-0" show-footer-line="true">
          <bar-chart
            :height="350"
            ref="bigChart"
            :chart-data="bigMonthChart.chartData"
            :extra-options="bigMonthChart.extraOptions"
          ></bar-chart>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";
import { DashboardFinancialService } from "@/services/customers/dashboard.financial.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "BillingServiceDash",
  data() {
    return {
      month: "",
      loading: false,
      options: [],
      bigMonthChart: {
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    BarChart,
  },
  methods: {
    initBigChart() {
      const vm = this;
      vm.loading = true;
      DashboardFinancialService.date(vm.month)
        .then((response) => {
          let barData = {
            datasets: response.values,
            labels: response.labels,
          };
          this.bigMonthChart.chartData = barData;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    moment.locale("pt-br");
    const today = moment();
    vm.month = today.format("YYYY-MM");
    for (let i = 0; i < 6; i++) {
      vm.options.push({
        key: today.format("YYYY-MM"),
        label: `${today.format("MMM").toUpperCase()}/${today.format("YYYY")}`,
      });
      today.subtract(1, "month");
    }
    vm.initBigChart();
  },
};
</script>
